export const REACT_FUNCTION_URL = "https://us-central1-marite-vidales.cloudfunctions.net/submit";